import React from 'react';
import { Box, Typography, Button, Link, Stack, Card } from '@mui/material';
import useResponsive from '../../../hooks/minimal/useResponsive';
import { MotionViewport, varFade } from '../../../components/minimal/animate';
import character4 from '../../../assets/illustrations/characters/character_4.png';
import mobilePhone from '../../../assets/mobile-phone.png';

import { m } from 'framer-motion';

const TicketScannerSection = () => {
    const isMobile = useResponsive('down', 'sm');
    return (
        <Stack
            id="ticket-scanner"
            component={MotionViewport}
            direction={isMobile ? "column" : "row"}
            sx={{ justifyContent: "space-between", gap: 4, px: isMobile ? 1 : "10%" }}
        >
            <Stack
                component={MotionViewport}
                sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    mx: 'auto',
                    gap: 4,
                    mt: 16
                }}>
                <m.div variants={varFade().inUp}>
                    <Typography variant="h2">
                        עם נימי קל לרכוש כרטיסים
                    </Typography>
                    <Typography variant="h4">
                        גם באצטדיון ענק על מכשיר קטן
                    </Typography>
                </m.div>
                <div style={{ display: 'flex', height: 'calc(100vh - 300px)', minHeight: '330px', justifyContent: 'center' }}>
                    {!isMobile && <div style={{ marginLeft: "-5px", }}>
                        <img src={character4} style={{
                            height: "100%",
                            maxWidth: '200px',
                            bottom: "0",
                            objectFit: "scale-down",
                            objectPosition: "left bottom"
                        }} />
                    </div>}
                    <div style={{ position: 'relative', flexGrow: 1 }}>
                        <img src={mobilePhone} style={{
                            width: "calc((100vh - 300px) * 0.4844)",
                            minWidth: "calc(330px * 0.4844)",
                            objectFit: "fill",
                        }} />
                        <div style={{
                            position: "absolute",
                            top: "7%",
                            left: "3%",
                            right: "2.7%",
                            bottom: "7%",
                            overflow: "hidden",
                        }}>
                            <video
                                style={{
                                    width: "100%",
                                    objectFit: "fill",
                                }}
                                src="/assets/video/hero-seat-picking.mov" autoPlay playsInline muted loop>
                            </video>
                        </div>
                    </div>
                </div>
            </Stack>
        </Stack >
    );
};

export default TicketScannerSection;